import React, { useState, useEffect } from 'react';


import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';

import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import Slider from '@mui/material/Slider';
import Select from 'react-select'

import { useSelector, useDispatch } from 'react-redux';
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { updateMenuCategory, updateMenuItem } from 'store/actions/restaurantMenu';
import { minutesToString } from "util/menuUtils";



const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    margin: 'auto',
    minWidth: 500,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
  main: {
    minHeight: 300
  },
  fieldset: {
    width: '100%',
  },
  // The selected option's settings sit indented under it, tied to it by a rule on the left.
  settings: {
    marginLeft: theme.spacing(4),
    marginBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    borderLeft: `2px solid ${theme.palette.primary.main}`,
  },
}));




const marks = [
  {
    value: 0,
    label: '00:00',
  },

  {
    value: 720,
    label: '12:00',
  },
  {
    value: 1440,
    label: '24:00',
  },
  {
    value: 2160,
    label: '12:00 +1',
  },
  {
    value: 2880,
    label: '24:00 +1',
  },
];

// Past 1440 the slider runs into the next day.
const nextDayNote = (end) => (end > 1440 ? ' (next day)' : '');

const selectStyles = {
  // Fixes the overlapping problem of the component
  menu: provided => ({ ...provided, zIndex: 9999 })
};

// Sits under its radio's label, lined up with the label text.
const OptionDescription = ({ children }) => (
  <Typography variant="body2" color="textSecondary" sx={{ ml: 4, mt: -1, mb: 0.75 }}>
    {children}
  </Typography>
);

OptionDescription.propTypes = {
  children: PropTypes.node,
};

const DaysField = ({ hint, ...selectProps }) => (
  <Box mt={1}>
    <Typography variant="subtitle2">Days</Typography>
    <Typography variant="caption" color="textSecondary" component="div" gutterBottom>{hint}</Typography>
    <Select
      maxMenuHeight={250}
      styles={selectStyles}
      isMulti
      options={weekDays}
      className="basic-multi-select"
      {...selectProps}
    />
  </Box>
);

DaysField.propTypes = {
  hint: PropTypes.string,
};




const weekDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(day => { return { value: day, label: day }; });

const MenuVisibility = (props) => {
  const classes = useStyles();
  const { menuItem, visibilityObj, category } = props
  const dispatch = useDispatch();


  const [visibility, setVisibility] = useState('')

  const [selectedDate, setSelectedDate] = useState(new Date());

  const [time, setTime] = useState([0, 1440]);
  const [activeDuration, setActiveDuration] = useState(null);
  // A new window starts at the typical dinner rush, 17:00 - 21:00.
  const [hideTime, setHideTime] = useState([1020, 1260]);
  const [hideDuringDays, setHideDuringDays] = useState([]);
  const categories = useSelector((state) => state.restaurantMenu.menuCategories);

  const updateCategory = (values) => dispatch(updateMenuCategory(values));
  const updateTheMenuItem = (item, values) => dispatch(updateMenuItem(item, values));


  // "Hide during ..." is category only, so menu item saves keep their existing shape.
  const clearHiddenWindow = category ? { hidden_begin: null, hidden_end: null, hiddenWeekDays: null } : {};

  const handleChange = (values) => {
    console.log('values', values);
    if (category) {
      const newCategory = { ...category, ...values }

      updateCategory(newCategory);

    }
    if (menuItem) {
      let newMenuItem = { ...menuItem, ...values }

      updateTheMenuItem(newMenuItem, categories);

    }
  };


  const updateHiddenUtil = (date) => {
    const updateObj = {
      active: true, active_begin: null,
      active_end: null,
      activeWeekDays: null,
      hidden_until: date.toISOString(),
      ...clearHiddenWindow
    };
    handleChange(updateObj);
  };

  const updateShowOnly = (newTime) => {
    let updateObj = {
      active: true, active_begin: newTime[0],
      active_end: newTime[1],
      hidden_until: null,
      active_days: null,
      activeWeekDays: null,
    };
    if (activeDuration) {
      updateObj = {
        ...activeDuration, active: true, active_begin: newTime[0],
        active_end: newTime[1]
      }
    }
   // console.log('updateObj time', updateObj);
    setActiveDuration(updateObj);
  };

  const getActiveDays = () => {
    if (activeDuration && activeDuration.activeWeekDays) {
      return activeDuration.activeWeekDays.map(day => ( {value: day, label: day}));
    } else {
      return [];
    }
  };

  const getHideDays = () => {
    if (visibilityObj && visibilityObj.hideDays) {
      return visibilityObj.hideDays.map(day => ( {value: day, label: day}));
    } else {
      return [];
    }
  };

  const selectHideWeekDays = (options) => {
    console.log('selectHideWeekDays', options);
    if (!options || options == null) {
      return;
    }

    const hideDays = options.map(day => day.value);

    handleChange({hideDays});
  };

  const selectShowOnlyFromWeekDays = (options) => {
    console.log('selectShowOnlyFromWeekDays', options);
    if (!options || options == null) {
      return;
    }

    const selectedDays = options.map(day => day.value);

    let updateObj = {
      active: true, active_begin: null,
      active_end: null,
      hidden_until: null,
      active_days: selectedDays
    };
    if (activeDuration) {
      updateObj = { ...activeDuration, active: true, activeWeekDays: selectedDays }
    }
   // console.log('updateObj', updateObj);
    setActiveDuration(updateObj);
  };

  const handleShowFromUpdate = () => {
    if (activeDuration !== null) {
      handleChange({ ...activeDuration, ...clearHiddenWindow });
    }

  };

  const getHideDuringDays = () => hideDuringDays.map(day => ({ value: day, label: day }));

  // Like "Hide until ...", "Hide during ..." saves as soon as it is picked or changed.
  const saveHideDuring = (newTime, newDays) => {
    handleChange({
      active: true, active_begin: null,
      active_end: null,
      active_days: null,
      activeWeekDays: null,
      hidden_until: null,
      hideDays: null,
      hidden_begin: newTime[0],
      hidden_end: newTime[1],
      hiddenWeekDays: newDays.length > 0 ? newDays : null
    });
  };

  const selectHideDuringWeekDays = (options) => {
    const newDays = (options || []).map(day => day.value);
    setHideDuringDays(newDays);
    saveHideDuring(hideTime, newDays);
  };

  const handleHideTimeChange = (event, newValue) => {
    setHideTime(newValue);
  };

  const handleHideTimeCommitted = (event, newValue) => {
    saveHideDuring(newValue, hideDuringDays);
  };

  const handleVisibilityChange = (event) => {
    setVisibility(event.target.value);
    let updateObj = null;
    if (event.target.value === 'hidden') {
      updateObj = {
        active: false, active_begin: null,
        active_end: null,
        active_days: null,
        activeWeekDays: null,
        hidden_until: null,
        ...clearHiddenWindow
      };
      handleChange(updateObj);
    } else if (event.target.value === 'hideUtil') {

      updateHiddenUtil(selectedDate);

    } else if (event.target.value === 'showOnlyFrom') {
      updateShowOnly(time);
    } else if (event.target.value === 'hideDuring') {
      saveHideDuring(hideTime, hideDuringDays);
    } else if (event.target.value === 'active') {
      const updateObj = {
        active: true, active_begin: null,
        active_end: null,
        hidden_until: null,
        hideDays: null,
        active_days: null, 
        activeWeekDays: null,
        ...clearHiddenWindow
      };
      handleChange(updateObj);
    }

  };

  useEffect(() => {
    if (!visibilityObj) {
      return;
    }
    // console.log('visibilityObj', visibilityObj);
    if (category && visibilityObj.hidden_begin != null && visibilityObj.hidden_end != null) {
      setVisibility('hideDuring');
      setHideTime([visibilityObj.hidden_begin, visibilityObj.hidden_end]);
      setHideDuringDays(visibilityObj.hiddenWeekDays || []);
    } else if (visibilityObj.hidden_until) {
      setVisibility('hideUtil');
      setSelectedDate(new Date(visibilityObj.hidden_until));
    } else if (visibilityObj.active_begin !== null && visibilityObj.active_end !== null) {
      setVisibility('showOnlyFrom');
      // Show the saved hours on the slider; Update saves activeDuration, which already holds them.
      const savedTime = [Number(visibilityObj.active_begin), Number(visibilityObj.active_end)];
      if (savedTime.every(Number.isFinite)) {
        setTime(savedTime);
      }
      const activeObj = {
        active: visibilityObj.active, active_begin: visibilityObj.active_begin, 
        active_end: visibilityObj.active_end,
        hidden_until: visibilityObj.hidden_until, 
        activeWeekDays: visibilityObj.activeWeekDays
      };
      setActiveDuration(activeObj);
    } else if (!visibilityObj.active) {
      setVisibility('hidden');
    } else {
      setVisibility('active');
    }

  }, [visibilityObj, category]);

  const handleTimeChange = (event, newValue) => {
    setTime(newValue);
    updateShowOnly(newValue);
  };

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
    updateHiddenUtil(newDate);
  };


  const itemName = category ? 'category' : 'dish';

  return (

    <Grid xs={12} container className={classes.main}>
      <Grid item xs={12}>
        <FormControl component="fieldset" className={classes.fieldset}>
          <FormLabel component="legend">Visibility</FormLabel>
          <Typography variant="caption" color="textSecondary" component="div" gutterBottom>
            When customers and the POS can see this {itemName}. Publish the menu for changes to take effect.
          </Typography>
          <RadioGroup aria-label="Visibility" name="visibility" value={visibility} onChange={handleVisibilityChange}>

            <FormControlLabel value="active" control={<Radio />} label="Active" />
            <OptionDescription>Always shown.</OptionDescription>

            <FormControlLabel value="hidden" control={<Radio />} label="Hidden From menu" />
            <OptionDescription>Not shown. Pick days to hide it on those days only.</OptionDescription>
            {visibility === 'hidden' ? (
              <Box className={classes.settings}>
                <DaysField
                  hint="Leave empty to hide every day"
                  defaultValue={getHideDays()}
                  onChange={selectHideWeekDays}
                  classNamePrefix="Select Hide days"
                />
              </Box>
            ) : null}

            <FormControlLabel value="hideUtil" control={<Radio />} label="Hide until ..." />
            <OptionDescription>Hidden until a date and time, then shown again.</OptionDescription>
            {visibility === 'hideUtil' ? (
              <Box className={classes.settings} pt={1}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DateTimePicker
                    variant="inline"
                    label="Show again from"
                    value={selectedDate}
                    onChange={handleDateChange}
                  />
                </LocalizationProvider>
              </Box>
            ) : null}

            <FormControlLabel value="showOnlyFrom" control={<Radio />} label="Show only from ..." />
            <OptionDescription>Shown only during set hours, on set days.</OptionDescription>
            {visibility === 'showOnlyFrom' ? (
              <Box className={classes.settings}>
                <Typography id="range-slider" gutterBottom>
                  Time: {`${minutesToString(time[0])} - ${minutesToString(time[1])}`}{nextDayNote(time[1])}
                </Typography>
                <Slider
                  sx={{ ml: 1, width: 'calc(100% - 48px)' }}
                  value={time}
                  step={15}
                  min={0}
                  max={2880}
                  marks={marks}
                  onChange={handleTimeChange}
                  valueLabelDisplay="auto"
                  aria-labelledby="range-slider"
                  valueLabelFormat={minutesToString}
                />
                <DaysField
                  hint="Leave empty to show every day"
                  defaultValue={getActiveDays()}
                  onChange={selectShowOnlyFromWeekDays}
                  classNamePrefix="Select Acitve days"
                />
                <Box mt={1.5} display="flex" alignItems="center" gap={1.5}>
                  <Button onClick={handleShowFromUpdate} color="primary" variant="contained" size="small">
                    Update
                  </Button>
                  <Typography variant="caption" color="textSecondary">Press Update to save the hours and days.</Typography>
                </Box>
              </Box>
            ) : null}

            {category ? <>
              <FormControlLabel value="hideDuring" control={<Radio />} label="Hide during ..." />
              <OptionDescription>Hidden during set hours, on set days. Shown at all other times.</OptionDescription>
            </> : null}
            {category && visibility === 'hideDuring' ? (
              <Box className={classes.settings}>
                <Typography id="hide-during-slider" gutterBottom>
                  Time: {`${minutesToString(hideTime[0])} - ${minutesToString(hideTime[1])}`}{nextDayNote(hideTime[1])}
                </Typography>
                <Slider
                  sx={{ ml: 1, width: 'calc(100% - 48px)' }}
                  value={hideTime}
                  step={15}
                  min={0}
                  max={2880}
                  marks={marks}
                  onChange={handleHideTimeChange}
                  onChangeCommitted={handleHideTimeCommitted}
                  valueLabelDisplay="auto"
                  aria-labelledby="hide-during-slider"
                  valueLabelFormat={minutesToString}
                />
                <DaysField
                  hint="Leave empty to hide every day"
                  defaultValue={getHideDuringDays()}
                  onChange={selectHideDuringWeekDays}
                  classNamePrefix="Select Hide during days"
                />
                <Typography variant="caption" color="textSecondary" component="div" mt={1}>
                  Changes save automatically.
                </Typography>
              </Box>
            ) : null}

          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>

  );
};

export default MenuVisibility;